export default "__VITE_ASSET__38be0a27__"